const WIKI_BASE = "https://wiki.knopka.click";

export function knopkaWikiLocale(locale: string | null | undefined): string {
  return (locale || "en").split("-")[0]?.toLowerCase() || "en";
}

export function knopkaCalendarTermsUrl(locale: string | null | undefined): string {
  return `${WIKI_BASE}/${knopkaWikiLocale(locale)}/calendar/terms`;
}

export function knopkaCalendarPrivacyUrl(locale: string | null | undefined): string {
  return `${WIKI_BASE}/${knopkaWikiLocale(locale)}/calendar/privacy`;
}
